import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";

import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/homework-student-results/homework-student-results.tsx",
    () => import("./homework-student-results"),
    <PageLoader />,
);
